import Cookies from 'js-cookie'

const DISPLAY_SETTINGS_COOKIE = 'displaySettings'

export interface DisplaySettingsCookieOptions {
  expires: number
  path: string
  sameSite: 'Lax'
  domain?: string
}

const hostnameWithoutPort = (hostname: string) => hostname.trim().toLowerCase().split(':')[0] || ''

/**
 * displaySettings cookie'sinin paylaşılacağı eTLD+1.
 * www.wingie.com → iq.wingie.com geçişinde currency korunsun diye `.wingie.com` gerekir.
 * wingie.de / wingie.co.uk gibi ccTLD'ler ayrı registrable domain; orada host-only kalır.
 */
export const getDisplaySettingsCookieDomain = (hostname?: string | null): string | undefined => {
  const fallbackHost = globalThis.window === undefined ? '' : globalThis.window.location.hostname
  const host = hostnameWithoutPort(hostname || fallbackHost)
  if (host === '' || host === 'localhost' || host === '127.0.0.1') {
    return undefined
  }

  if (host === 'wingie.com' || host.endsWith('.wingie.com')) {
    return '.wingie.com'
  }

  if (host === 'enuygun.com' || host.endsWith('.enuygun.com')) {
    return '.enuygun.com'
  }

  return undefined
}

export const getDisplaySettingsCookieOptions = (hostname?: string | null): DisplaySettingsCookieOptions => {
  const domain = getDisplaySettingsCookieDomain(hostname)

  return {
    expires: 365,
    path: '/',
    sameSite: 'Lax',
    ...(domain ? { domain } : {}),
  }
}

/** Host-only leftover cookie'yi silip displaySettings'i paylaşılabilir domain ile yazar. */
export const persistDisplaySettingsCookie = (cookieData: unknown, hostname?: string | null): void => {
  Cookies.remove(DISPLAY_SETTINGS_COOKIE, { path: '/' })
  Cookies.set(DISPLAY_SETTINGS_COOKIE, JSON.stringify(cookieData), getDisplaySettingsCookieOptions(hostname))
}
